export default __webpack_public_path__ + "static/media/loadingV2.cd679179.svg";